module.exports = __webpack_public_path__ + "img/zwanger.f94726be.jpeg";